import Component from 'vue-class-component';
import { Mixins } from 'vue-property-decorator';
import { COURSE_EVENTS } from '@/content/values/events';
import { STORE } from '@/core/store/core.store';
import CourseActions from '@/content/actions/course.actions';
import { SectionsProvider } from '@/content/providers/sections.provider';
import KEYS from '@/values/keys';
import  i18n   from '@/content/lang/content.i18n';
import { COURSES_EVENTS } from '@/courses/values/courses-events.values';
import EdUploadCourseMaterial from '@/content/pages/create-lesson/modals/ed-upload-course-material/ed-upload-course-material.vue';
import { IParamsModalConfirmation } from '@/plugins/ed-modal/interfaces/params-modal-confirmation.interface';
import { MaterialMixin } from '@/courses/mixins/material.mixin';
import ToolService from '@/providers/tools';
import EdMembersConnected from '@/core/components/ed-members-connected/ed-members-connected.component.vue';
import { SCREEN_MIRRORING_EVENTS } from '@/values/screen.mirroring.values';
import EdConfirmMessageComponent from '../ed-confirm-message/ed-confirm-message.component.vue';

@Component({
  name: 'ed-section-material-object',
  components: {
    EdMembersConnected
  }
})
export default class EdSectionMaterialObject extends Mixins(MaterialMixin) {

  /* Data */
  public teacherOnly: boolean = false;
  public selected: boolean = false;

  /* Computed */
  get nodes() {
    return this.course.materials.nodes;
  }

  get opacity(){
    if(this.teacherOnlyComp)
      return { opacity:'0.5' }
  }

  get teacherOnlyComp() {
    let parent = SectionsProvider.getSectionMaterialFromId(this.nodes, this.material.sectionParentId);
    if(parent) {
      return parent.teacherOnly ? parent.teacherOnly : this.material.data.teacherOnly;
    } else {
      return this.material.data.teacherOnly;
    }
  }

  get escapedName(){
    return ToolService.exitSpecialChars(this.material.data.title);
  }

  get membersConnected() {
    return this.$store.state.AppStore.membersPosition.filter(m => {
      return (
        m.courseId == this.courseID && 
        m.classId == this.classID &&
        m.sectionId == this.material.relatedContentId && 
        !m.isFolder
      );
    });
  }

  get nameStyle(): any {
    let maxWidth = this.options.editable ? 'calc(100% - 60px)' : '100%';
    return { maxWidth };
  }

  get nameStyleText(): any {
    return { maxWidth: `calc(100% - ${(this.membersConnected.length * 15)}px` };
  }

  /* Methods */
  private showModal( body: any, type: string) {
    this.$EdModal.createMessageModal({
      title: i18n.t('courses.materials.courseMaterials') ,
      body: body,
      type: type
    });  
  }

  public getConfirmationModalParams(materialId: string , dataId: string): IParamsModalConfirmation {
    return {
      body: `${this.$i18n.t('courses.materials.deleteCourseMaterial')}`,
      action: () => {
        this.deleteCourseMaterial(materialId , dataId , true);
      }
    }
  }

  public showMaterial(material: any, emitScreenMirroringEvent : boolean = true) {
    let materialData = {materialId: material.relatedContentId , 
      courseId: this.courseID , classId: this.classID, title: this.course.title};
    this.goToMaterialPreview(materialData);
    if(!this.options.editable) {
      if(!this.material.sectionParentId) {
        this.$edEventBus.$emit(COURSES_EVENTS.SECTION_SELECTED, {
          sectionId: null,
          courseId: this.courseID,
          classId: this.classID
        });
        this.$edEventBus.$emit(COURSES_EVENTS.SECTION_OPENED, {
          sectionId: null, 
          opened: null,
          courseId: this.courseID,
          classId: this.classID
        });
        let sectionsOpened: number[] = [null];
        this.$emit('opened', sectionsOpened);
      }       
    }
    this.setSectionInStorage(this.material.relatedContentId);

    if( emitScreenMirroringEvent ) {
      var target = this.target(SCREEN_MIRRORING_EVENTS.ON_OPEN_SECTION_MATERIAL);
      this.$edEventBus.$emit( SCREEN_MIRRORING_EVENTS.CLICK, this, {target:target});
    }

  }

  public editMaterial(material: any) {
    this.$EdModal.createModal(EdUploadCourseMaterial,  {material: material , editing: true,
      contentType: this.contentType});
  }
  
  public prepareCourseMaterialDelete(materialId: string , dataId: string) { 
    let relatedCourseMaterials: boolean = SectionsProvider.getCourseMaterialsRelated(this.course.sections, materialId);
    if(relatedCourseMaterials) { 
      this.$EdModal.createConfirmationModal(this.getConfirmationModalParams(materialId , dataId ));
    } else {
      this.deleteCourseMaterial(materialId , dataId);
    }
  }

  public deleteCourseMaterial(materialId: string , dataId: string , relatedCourseMaterials: boolean = false) {
    this.editingObject = true;
    this.$edEventBus.$emit(COURSES_EVENTS.COURSE_MATERIAL_REMOVED, materialId);
    this.$Courses.Store.removeCourseMaterialA({
      materialId, dataId , relatedCourseMaterials , courseId: this.courseID , classId: this.classID
    })
    .catch(() => this.showModal(i18n.t('courses.materials.errorDeleting') , KEYS.EVENT_TYPES.DANGER))
    .finally(() => {
      this.editingObject = false;
     });
  }

  public async validateParentVisibility(parentSectionId){
    if(parentSectionId) {
      let parentSection = SectionsProvider.getSectionMaterialFromId(this.nodes, parentSectionId);
      if (!this.teacherOnly) {
        while(parentSection.teacherOnly) {
          parentSection.teacherOnly = !parentSection.teacherOnly;
          parentSection.saveMessageTeacherOnly = this.dontAskAgaingTeaherOnly;
          this.setTeacherOnlyMaterial(parentSection);
          parentSection = SectionsProvider.getSectionMaterialFromId(this.nodes,parentSectionId.parentId);
          if(parentSection == null){
            return;
          }
        }
      } else {
        let materialsCount = this.getMaterialsCount(parentSection);
        let nodesTeacherOnlyCount = parentSection.nodes.filter(section => section.teacherOnly).length;
        while (parentSection.materials.length === materialsCount && parentSection.nodes.length === nodesTeacherOnlyCount) {
          parentSection.teacherOnly = !parentSection.teacherOnly;
          parentSection.saveMessageTeacherOnly = this.dontAskAgaingTeaherOnly;
          await this.setTeacherOnlyMaterial(parentSection);
          parentSection = SectionsProvider.getSectionMaterialFromId(this.nodes, parentSectionId.parentId);
          if(parentSection == null){
            return;
          }
          materialsCount = this.getMaterialsCount(parentSection);
          nodesTeacherOnlyCount = parentSection.nodes.filter(section => section.teacherOnly).length;
        }
      }
    }
  }

  getMaterialsCount(section) {
    return section.materials.filter(material => { 
      if (material.data.teacherOnly || material.relatedContentId == this.material.relatedContentId) {
        return material;
      }
    }).length;
  }

  public target(screenMirroringEventName:string) {
    return screenMirroringEventName.replace('{sectionMaterialId}', this.material.relatedContentId);
  }

  public showSectionMaterialWithoutMirroringEvent() {
    this.showMaterial(this.material, false);
  }

  public changeVisible() {
    if(this.course.showTeacherOnlyMessage) {
      this.$EdModal.createModal(EdConfirmMessageComponent, {
        onConfirmMessage: this.confirmMessage
      })
    } else {
      this.changeVisibleAction();
    }
  }

  public async changeVisibleAction() {
    this.teacherOnly = !this.teacherOnlyComp;
    let newMaterial = { ...this.material };
    newMaterial.data.teacherOnly = this.teacherOnly;
    newMaterial.data.saveMessageTeacherOnly = this.dontAskAgaingTeaherOnly;
    await this.setTeacherOnlyMaterial(newMaterial);
    this.validateParentVisibility(this.material.sectionParentId);
    this.setParentWillUpdate(false);
  }

  confirmMessage(data) {
    this.dontAskAgaingTeaherOnly = data;
    this.changeVisibleAction();
  }

  /* Hooks */
  public created() {
    this.teacherOnly = this.material.data.teacherOnly;
    this.$edEventBus.$on(COURSE_EVENTS.OBJECT_SELECTED, ({materialId, courseId , classId}) => {
      let classIdCondition: boolean = this.options.editable ? true : classId == this.classID;
      if(courseId == this.courseID && classIdCondition) {
        this.selected = materialId === this.material.relatedContentId;
        if(this.selected) {
          this.$emit('open');
        }
      }
    });

    this.$edEventBus.$on( this.target(SCREEN_MIRRORING_EVENTS.ON_OPEN_SECTION_MATERIAL), this.showSectionMaterialWithoutMirroringEvent);
  }

  public beforeDestroy() {
    this.$edEventBus.$off(this.target(SCREEN_MIRRORING_EVENTS.ON_OPEN_SECTION_MATERIAL));
  }

}